module.exports = __webpack_public_path__ + "img/pagination-docs-left.0a422ee3.svg";